import React, { useState } from 'react';
import { X, Calendar, Clock, Save } from 'lucide-react';

const BlockCalendarModal = ({ isOpen, onClose,createEventClose, onSave, initialDate = '', initialStartTime = '', initialEndTime = '' }) => {
  const [selectedDate, setSelectedDate] = useState(initialDate || '');
  const [isAllDay, setIsAllDay] = useState(!(initialStartTime && initialEndTime));
  const [startTime, setStartTime] = useState(initialStartTime || '06:00');
  const [endTime, setEndTime] = useState(initialEndTime || '21:00');
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    if (!selectedDate) {
      alert('Please select a date');
      return;
    }

    if (!isAllDay && startTime >= endTime) {
      alert('Start time must be before end time');
      return;
    }

    setIsLoading(true);

    const dndData = {
      start: isAllDay 
        ? `${selectedDate}T00:00:00` 
        : `${selectedDate}T${startTime}:00`,
      end: isAllDay 
        ? `${selectedDate}T23:59:59` 
        : `${selectedDate}T${endTime}:00`
    };

    try {
      await onSave(dndData);
      handleClose();
    } catch (error) {
      console.error('Error saving DND:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setSelectedDate('');
    setIsAllDay(true);
    setStartTime('06:00');
    setEndTime('21:00');
    onClose();
    createEventClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-light-dark backdrop-blur-md rounded-2xl p-6 w-full max-w-md mx-4 border border-white/30 shadow-2xl">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <div 
            className="p-2 bg-red-500/10 rounded-xl"
            
            >
              <Calendar className="w-6 h-6 text-red-600" />
            </div>
            <h2 className="text-xl font-bold heading-white">Block Calendar</h2>
          </div>
          <button
            onClick={handleClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="space-y-4">
          {/* Date Selection */}
          <div>
            <label className="block text-sm font-medium subheading mb-2">
              Select Date
            </label>
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              min={new Date().toISOString().split('T')[0]}
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all"
              required
            />
          </div>

          {/* All Day Toggle */}
          <div className="flex items-center justify-between p-4 bg-white/20 rounded-lg">
            <div className="flex items-center space-x-3 ">
              <Clock className="w-5 h-5 subheading" />
              <span className="text-sm font-medium subheading ">All Day</span>
            </div>
              <button
                onClick={() => setIsAllDay(!isAllDay)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-color  s ${
                isAllDay ? '' : 'bg-gray-300'
              }`}
              style={{ backgroundColor: isAllDay ? '#004877' : undefined }}
              >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  isAllDay ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>

          {/* Time Selection */}
          {!isAllDay && (
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium subheading mb-2">
                  Start Time
                </label>
                <input
                  type="time"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-200 subheading rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all"
                />
              </div>
              <div>
                <label className="block text-sm font-medium subheading mb-2">
                  End Time
                </label>
                <input
                  type="time"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all"
                />
              </div>
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3 mt-6">
          <button
            onClick={handleClose}
            className="flex-1 border border-gray-200 heading-white rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={isLoading}
            className="flex-1 flex items-center justify-center space-x-2 px-4 py-3  buttonHeading"
          >
            <Save className="w-4 h-4" />
            <span>{isLoading ? 'Saving...' : 'Block Calendar'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockCalendarModal;